
import service from "../api/services/attendanceService";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getAttendanceList(context, reqData) {
      return service.getAttendanceList(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
    getAttendanceById(context, reqData) {
      return service.getAttendanceById(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
    getStudents(context, reqData) {
      return service.getStudents(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
    submitAttendance(context, reqData) {
      return service.submitAttendance(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
    getBatchSubjects(context, reqData) {
      return service.getBatchSubjects(reqData).then((response = {}) => {
        return response.responseData;
      }).catch((error) => {
        return Promise.reject(error);
      });
    },
  },
};
